import React, { useEffect } from 'react'
import Banner from '../Components/Banner';
import BannerImage from "../Images/service-banner.jpg";
import ContactSection from '../Components/ContactSection';
import Ser1 from "../Images/weddingEvents/1.jpg";
import Ser2 from "../Images/weddingEvents/2.jpg";
import Ser3 from "../Images/weddingEvents/3.jpg";
import Ser4 from "../Images/weddingEvents/4.jpg";
import Ser5 from "../Images/weddingEvents/5.jpg";
import Ser6 from "../Images/weddingEvents/6.jpg";
import Ser7 from "../Images/weddingEvents/7.jpg";
import Ser8 from "../Images/weddingEvents/8.jpg";
import { Col, Container, Row, Card } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const Weddings = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0,0);
    }, [location.key])
  const bannerTitle = (
    <>
      Weddings
    </>
  );
  const bannerContent = "";
  const bannerConclude = "";
  const serviceData = [
    {
      id: 1,
      title: 'Engagement Ceremony',
      image: Ser1,
      description: 'Engagement Ceremony'
    },
    {
      id: 2,
      title: 'Haldi Ceremony',
      image: Ser2,
      description: 'Haldi Ceremony'
    },
    {
      id: 3,
      title: 'Tilak Ceremony',
      image: Ser3,
      description: 'Tilak Ceremony'
    },
    {
      id: 4,
      title: 'Bachelorette Party',
      image: Ser4,
      description: 'Bachelorette Party'
    },
    {
      id: 5,
      title: 'Mehandi Ceremony',
      image: Ser5,
      description: 'Mehandi Ceremony'
    },
    {
      id: 6,
      title: 'Pellikoduku  Pellikuthuru Ceremony',
      image: Ser6,
      description: 'Pellikoduku  Pellikuthuru Ceremony'
    },
    {
      id: 7,
      title: 'Reception',
      image: Ser7,
      description: 'Reception'
    },
    {
      id: 8,
      title: 'Sangeeth',
      image: Ser8,
      description: 'Sangeeth'
    }
  ];
  
  return (
    <div className='home-content'>
      <Banner image={BannerImage} propAlt={"Home Banner"} 
          bannerTitle={bannerTitle} bannerContent={bannerContent} bannerConclude={bannerConclude} />
      <section className="services-section py-5">
          <Container>
            
            <h2 className="text-center mb-5">Elegant Dining Experiences in</h2>
            
            <Row className="g-4">
              {serviceData.map((service, index) => (
                <Col key={service.id} xs={12} sm={6} md={4} lg={3}>
                  <Card className={`service-card h-100 ${((index + 1) % 2 === 0) ? 'mt-5' : ''}`}>
                    <div className="card-img-wrapper">
                      <Card.Img variant="top" src={service.image} alt={service.title} />
                    </div>
                    <Card.Body>
                      <Card.Title>
                        <div className="stretched-link text-decoration-none text-dark">
                          {service.title}
                        </div>
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <ContactSection />
    </div>
  )
}

export default Weddings